import { Button } from '@/components/ui/button';
import { Trophy } from 'lucide-react';

interface ScoreActionButtonProps {
  hasScore?: boolean;
  onClick: () => void;
}

export function ScoreActionButton({ hasScore = false, onClick }: ScoreActionButtonProps) {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
    >
      <Trophy className="mr-2 h-4 w-4" />
      {hasScore ? 'Update Score' : 'Log Score'}
    </Button>
  );
}
